// src/fonts/index.js

import NauWeb from "./nau-web-title.woff2";
import NauTall from "./nau-web-tall.woff2";

export { NauWeb, NauTall };



// WEBPACK FOOTER //
// ./src/fonts/index.js